import "./styles.css";

import type { VilniusRuntimeBridge } from "./app/bootstrap.ts";
import { installBootstrapFetchRetry } from "./app/bootstrapFetch.ts";

declare global {
  interface Window {
    __VILNIUS__?: VilniusRuntimeBridge;
    __VILNIUS_BOOT__?: {
      readonly note: (message: string) => void;
      readonly ready: () => void;
      readonly fail: (error: unknown) => void;
    };
  }
}

try {
  window.__VILNIUS_BOOT__?.note("Preparing nearby streets and landmarks…");
  const { bootstrapVilnius } = await import("./app/bootstrap.ts");
  const restoreFetch = installBootstrapFetchRetry({
    onRetry({ attempt, maximumAttempts }): void {
      window.__VILNIUS_BOOT__?.note(
        `Connection interrupted. Retrying city data (${attempt}/${maximumAttempts})…`,
      );
    },
  });
  const application = await bootstrapVilnius().finally(restoreFetch);
  window.__VILNIUS__ = application.bridge;
  window.__VILNIUS_BOOT__?.ready();

  window.addEventListener(
    "beforeunload",
    () => {
      application.dispose();
      delete window.__VILNIUS__;
    },
    { once: true },
  );
} catch (error) {
  window.__VILNIUS_BOOT__?.fail(error);
  console.error("Vilnius failed to start.", error);
}
